import React from 'react';
import { FormAlert } from './form';
import { PAGE_FEEDBACK_ID } from '../utils/mainScroll';

/**
 * Bloque estándar de éxito/error bajo el encabezado de página (#page-feedback).
 */
export default function PageFeedbackBlock({
  success,
  error,
  errorAction = null,
  successAction = null,
  className = '',
}) {
  return (
    <div id={PAGE_FEEDBACK_ID} className={className}>
      <FormAlert type="success" className="mb-2" action={successAction}>
        {success || null}
      </FormAlert>
      <FormAlert type="error" className="mb-2" action={errorAction}>
        {error || null}
      </FormAlert>
    </div>
  );
}
